import { fromJS } from 'immutable'

export default fromJS({
  global: {
    nth: (() => {
      const below20 = [
        'Zeroth',
        'First',
        'Second',
        'Third',
        'Fourth',
        'Fifth',
        'Sixth',
        'Seventh',
        'Eighth',
        'Ninth',
        'Tenth',
        'Eleventh',
        'Twelfth',
        'Thirteenth',
        'Fourteenth',
        'Fifteenth',
        'Sixteenth',
        'Seventeenth',
        'Eighteenth',
        'Nineteenth'
      ]
      const decaPrefix = ['Twent', 'Thirt', 'Fort', 'Fift', 'Sixt', 'Sevent', 'Eight', 'Ninet']
      return number =>
        20 > number
          ? below20[number]
          : 0 == number % 10 && 100 > number
            ? `${decaPrefix[number / 10 - 2]}ieth`
            : 100 > number
              ? `${decaPrefix[Math.floor(number / 10) - 2]}y ${below20[number % 10]}`
              : 100 == number
                ? 'Hundredth'
                : 'Another'
    })()
  },
  questions: {
    noAlt: 'Missing alternative text for this image',
    noAnswers: 'No answer option, please click next to continue.',
    placeholder: 'Please specify...',
    pleaseSelect: 'Please select...',
    rotateLandscape: 'Please turn off Orientation Lock on your phone and rotate to landscape to continue.',
    rotatePortrait: 'Please rotate your phone from landscape to portrait to continue.',
    cn: {
      placeholder: 'Start typing or click the mic icon to speak'
    },
    ir: {
      selectWebCam: "Select webcam (if available) or click 'Browse' to upload from your device",
      uploadOnly: "Click 'Browse' to upload from your device",
      noWebCam: 'No webcam detected',
      selectFile: 'Please select a file',
      uploadFile: 'PLEASE, UPLOAD THE FILE',
      accessCamUpload: 'ACCESS CAMERA/UPLOAD',
      browse: 'BROWSE',
      uploadPhoto: 'Upload a photo',
      camera: 'Web Camera',
      instead: 'instead',
      capture: 'CAPTURE',
      somethingWrong: 'Sorry, something went wrong. Please, try again.',
      couldntRead: "Sorry, we couldn't read the code!",
      couldntProcess: "Sorry, we couldn't process your image!",
      inValidCode: 'Please, submit the valid code',
      moveOn: 'Please try again or submit your photo and move on',
      tryAgain: 'Please try again',
      dataReceived: 'Data received!',
      enterManually: 'Please try again or enter the data manually below',
      positionQR:
        'Please position the QR code in front of your camera to fit it into the red frame or upload it from your computer.',
      uploadQR: 'Upload the QR code from your computer',
      uploadQRMobile: 'Upload the QR code from your device',
      positionQRMobile: 'Please position the QR code in front of your camera or upload it from your device.',
      analyzing: 'Analyzing image, please wait',
      submit: 'SUBMIT',
      startOver: 'START OVER',
      allDone: 'ALL DONE!',
      cantAnalyze:
        "Attention - we couldn't render this image. Please try resubmitting it or choose a more generic image format (JPG, PNG, GIF, BMP)",
      wrongFormat:
        "We're sorry - we don't support this file format. Please upload a supported image type (JPG, PNG, GIF, BMP, TIF, PDF, SVG)"
    },
    vr: {
      noWebCam: 'No webcam detected',
      uploadVideo: 'Upload a video',
      skip: 'Skip?',
      accessCamUpload: 'ACCESS CAMERA/UPLOAD',
      browse: 'BROWSE',
      instead: 'instead',
      or: 'or',
      stopRecording: 'Stop recording',
      willBeStopped: 'Recording will stop at <b>5 minutes</b>',
      stopOnDone: "Stop recording when you're done!",
      record: 'RECORD',
      somethingWrong: 'Sorry, something went wrong. Please, try again.',
      dataReceived: 'Data received!',
      microphone: 'Microphone',
      camera: 'Web Camera',
      selectMicrophone: 'Select your microphone',
      selectCam: 'Select your web camera',
      submit: 'SUBMIT',
      upload: 'UPLOAD',
      playback: 'PLAYBACK',
      stopPlayback: 'STOP PLAYBACK',
      startOver: 'START OVER',
      allDone: 'ALL DONE!',
      alternativeRecordSpan: 'Please, upload a video-clip from your computer-device.<br/>Alternatively, you can &nbsp;',
      alrenativeRecordHref: 'record the video with a webcam',
      cantAnalyze:
        "Attention - we couldn't render this video. Please try resubmitting it or choose a more generic video format (MP4, M4V, WEBPM)",
      wrongFormat:
        "We're sorry - we don't support this file format. Please upload a supported video type (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)"
    },
    cjc: {
      choose: 'CHOOSE',
      pleaseChoose: 'Please choose',
      this: 'THIS',
      one: 'one',
      myChoice: 'MY CHOICE'
    },
    hm: {
      addComment: 'Please add a comment below',
      commentMandatoryPlaceHolder: 'Please, add mandatory comment... ',
      commentOptionalPlaceHolder: 'Please, add optional comment... ',
      dragPin: 'Drag to reposition (long click/tap for precision pinning). ',
      removePin: 'Drag outside of the image to delete.  ',
      editComment: 'Click/tap pin to edit comment. ',
      addPin: 'Please drag the pin from the panel below and drop it at a spot of your choice on the image.',
      addPins: 'Please drag the pins from the panel below and drop them at a spot of your choice on the image. ',
      leavePins: (minPoints, maxPoints) =>
        `Please leave at least ${minPoints} but no more than ${maxPoints} pins of every kind.`,
      leavePinsAny: (minPoints, maxPoints) =>
        `Please leave at least ${minPoints} but no more than ${maxPoints} pins of any kind.`,
      leavePinsPerPage: (minPoints, maxPoints) =>
        `Please leave at least ${minPoints} but no more than ${maxPoints} pins.`,
      leavePinsWithOff: maxPoints => `Please leave no more than ${maxPoints} pins of every kind or click Next to skip.`,
      leavePinsWithOffAny: maxPoints =>
        `Please leave no more than ${maxPoints} pins of any kind or click Next to skip.`,
      leavePinsPerPageWithOff: maxPoints => `Please leave no more than ${maxPoints} pins or click Next to skip.`,
      leavePinWithOff: `Please leave no more than 1 pin of every kind or click Next to skip.`,
      leavePinWithOffAny: `Please leave no more than 1 pin of any kind or click Next to skip.`,
      leavePinPerPageWithOff: 'Please leave no more than 1 pin or click Next to skip.',
      leaveExactlyPin: `Please leave 1 pin of every kind.`,
      leaveExactlyPinAny: `Please leave 1 pin of any kind.`,
      leaveExactlyPinPerPage: 'Please leave 1 pin.',
      leaveExactlyPins: maxPoints => `Please leave ${maxPoints} pins of every kind.`,
      leaveExactlyPinsAny: maxPoints => `Please leave ${maxPoints} pins of any kind.`,
      leaveExactlyPinsPerPage: maxPoints => `Please leave ${maxPoints} pins.`,
      leaveComment: 'Type below the image to leave comment.',
      noAnswers: 'No answer option, please click next to continue',
      outOfPins: 'you are out of pins',
      pinsBehavior: 'As you move across the image you’ll see areas that will be highlighted with a single pin drop.',
      clusters: 'You’ll only be able to place pins in these highlighted areas.',
      contentAware: 'You can drop pins inside or outside of the highlighted areas.'
    },
    mp: {
      expand_note: 'Please hover over or click on image(s) to expand',
      rb_note: rows => `Please select only 1 response per item${rows ? ' below' : ''}:`,
      cb_note: (min, max, rows) => {
        if (min === max) {
          return `Please select ${min !== 1 ? 'any' : 'only'} ${min} response${min !== 1 ? 's' : ''} per item${
            rows ? ' below' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Please select at least ${min} response${min !== 1 ? 's' : ''} but no more than ${max} per item${
            rows ? ' below' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Please select at least ${min} response${min !== 1 ? 's' : ''} per item${rows ? ' below' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Please select no more than ${max} response${max !== 1 ? 's' : ''} per item${rows ? ' below' : ''}:`
        } else {
          return 'Check all that apply:'
        }
      }
    },
    sh: {
      note: "Click a product to zoom in and add to your virtual cart if you'd buy it in the store",
      amazonNote: 'Click on a product to zoom in or add multiples of a product to your cart',
      fullCart: 'Your cart is full!',
      qty: 'QTY',
      addToCart: 'ADD TO CART',
      deleteFromCart: 'Delete',
      each: 'each',
      items: 'items',
      emptyCard: 'Your cart is empty',
      total: 'Cart',
      clearCart: 'Clear Cart',
      backToStore: 'Back To Store',
      na: 'None of the above',
      closedFullscreenLabel: 'LAUNCH FULLSCREEN SHELF TEST',
      next: 'NEXT',
      researcherWarning: 'Researcher mode warning: ',
      xraysWarning: 'Ghost mode warning: ',
      shelfError_out_of_shelves:
        'Too many products, the width of the products exceeds the maximum allowed. Try to enable full-screen mode or reduce the number of products  to increase the width.',
      shelfError_too_much_products:
        'Too many products, the width of the products exceeds the maximum allowed. Try to enable full-screen mode or reduce the number of products to increase the width.',
      shelfError_out_of_shelves_fullscreen:
        'Too many products, the width of products exceeds the maximum allowed. Scale products down or reduce the number of products.',
      shelfError_too_much_products_fullscreen:
        'Too many products, the width of products exceeds the maximum allowed. Scale products down or reduce the number of products.',
      shelfError_longWidget:
        'To many shelves blocks. Try to enable full-screen mode or reduce the number of products to increase the width.',
      shelfError_too_much_shelves: 'Too much shelves',
      emptyCartError: min => `Please add to cart at least ${min} product${min !== 1 ? 's' : ''}. `,
      maxCartCountError: max => `Please add no more than ${max} products to your cart. `,
      maxSpentError: max => `Please spend no more than ${max}. `,
      scrollError: `Please scroll fully left and right to proceed in the survey. `,
      maxProductCountError: max => `Please add no more than a quantity of ${max} to your cart for each product. `,
      application: {
        iosText:
          '<h>The next section involves a virtual shopping exercise that can be experienced in augmented reality (AR).</h><br/><br/>' +
          'If you are in a stable environment with enough room, and an unobstructed wall you can walk along and shop virtually without distraction, please download the app and check if your smartphone supports AR.<br/><br/>' +
          'Otherwise, you may continue taking<br/>' +
          'this exercise in your browser. ',
        androidText:
          '<h>The next section involves a virtual shopping exercise that can be experienced in augmented reality (AR).</h><br/><br/>' +
          'If you are in a stable environment with enough room, and an unobstructed wall you can walk along and shop virtually without distraction, please download the app and check if your smartphone supports AR.<br/><br/>' +
          'Otherwise, you may continue taking<br/>' +
          'this exercise in your browser. ',
        buttonYes: 'GO TO AR APP',
        buttonNo: 'CONTINUE WITHOUT AR'
      }
    },
    rb: {
      note: 'Please select only 1 item:'
    },
    vo: {
      note: 'Please watch the video till the end'
    },
    cb: {
      note: (min, max) => {
        if (1 === min && 5000 === max) {
          return 'Please select all that apply:'
        } else if (min === max) {
          return `Please select ${min !== 1 ? 'any' : 'only'} ${min} item${min !== 1 ? 's' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Please select at least ${min} item${min !== 1 ? 's' : ''} but no more than ${max}:`
        } else if (5000 === max && min > 0) {
          return `Please select at least ${min} item${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Please select no more than ${max} item${max !== 1 ? 's' : ''}:`
        } else {
          return 'Please select all that apply:'
        }
      }
    },
    oe: {
      na: 'Not applicable',
      note: (min, max, optional) => {
        if (min === max) {
          return `Please type ${1 !== min ? 'any' : 'exactly'} ${min} character${1 !== min ? 's' : ''}${
            optional ? ' (optional)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Please type at least ${min} character${1 !== min ? 's' : ''} but no more than ${max}${
            optional ? ' (optional)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Please type at least ${min} character${1 !== min ? 's' : ''}${optional ? ' (optional)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Please type no more than ${max} character${1 !== min ? 's' : ''}${optional ? ' (optional)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Please fill in the following fields:'
    },
    mx: {
      note: 'Please move the highlighted sliders to continue',
      dragSlider: 'Drag left or right to answer'
    },
    psc: {
      dragLeftRight: 'Drag left or right to answer'
    },
    ps: {
      note: (value, remaining) => `Please distribute ${remaining ? 'remaining' : ''} ${value} between the items below`,
      allDone: `All done`,
      total: `Total:`,
      dragSlider: 'Drag left or right to answer'
    },
    cx: {
      note: 'Open the drop-down menu and start typing your answer to autoscroll or select it manually'
    },
    ro: {
      note: 'Drag up or down to reorder:'
    },
    md: {
      note1: 'Please click/tap the item of your <b>first choice</b>.<br/>Click/tap again to clear the choice.',
      note2: 'Now please click/tap the item of your <b>last choice</b>.<br/>Click/tap again to clear the choice.',
      note3: 'Thanks! Continue to the next question<br/>or click any unselected item to start over.'
    },
    aro: {
      note: 'Please choose one item from each pair:'
    },
    wd: {
      note: 'Make sure that each subsequent value is greater than the previous one.'
    },
    emd: {
      note: 'Please watch the video till the end\n',
      noAnswers: 'No answer option, please click next to continue.',
      start: 'Click and hold to start',
      resume: 'Click and hold to resume',
      continue: "You're ready! <br />Click <strong>Next</strong> to continue",
      continueMobile: "You're ready! <br />Click <strong>here</strong> to continue",
      training: {
        session: 'training session',
        note: 'Please finish training',
        moveLeft: 'Please drag the dial all the way to the <strong>left</strong>',
        moveBottom: 'Please drag the dial all the way to the <strong>bottom</strong>',
        moveRight: 'Now, please drag the dial all the way to the <strong>right</strong>',
        moveTop: 'Now, please drag the dial all the way to the <strong>top</strong>',
        success: 'Great job!'
      },
      tap: `tap anywhere <br /> to unmute`
    },
    sft: {
      noAnswers: 'No answer option, please click next to continue',
      note: 'Please answer as quickly as you can with the answer that intuitively feels right',
      imageError: 'No image exposure time chosen',
      finish: 'You are all done! <br /> Please click Next to continue',
      training: {
        start:
          '<p>This question will rapidly show you different words and will require your concentration. ' +
          'You&apos;ll need to react quickly to answer.</p> <p>Ready to practice?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Tap "{buttonLeft}"`
            : (mouse ? `Click "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Hit "{keyBtnLeft}" key` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Tap "{buttonRight}"`
            : (mouse ? `Click "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Hit "{keyBtnRight}" key` : ''),
        fail: () => 'Too slow',
        success: () => 'Great!',
        finish: () =>
          '<p><strong> Excellent!</strong></p><p>Please make sure you are not<br />' +
          'going to be distracted in the<br/> next 2-3 minutes</p><p>Click Next to start when ready.</p>'
      },
      buttons: {
        start: 'Start',
        yesno: {
          left: 'Yes',
          right: 'No'
        },
        matches: {
          left: 'Match',
          right: 'Not Match'
        },
        fits: {
          left: 'Fit',
          right: 'Not Fit'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        },
        noyes: {
          left: 'Yes',
          right: 'No'
        },
        matchesRev: {
          left: 'Match',
          right: 'Not Match'
        },
        fitsRev: {
          left: 'Fit',
          right: 'Not Fit'
        },
        thumbsRev: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
